export default __webpack_public_path__ + "static/media/trust-in-teams.6405a2cc.svg";